import { serverClock } from "@artis/sdk";

export type LpStage = "arrived" | "calculated" | "main" | "painted";

/** One stage's clocks, taken in the context that observed the stage (ADR-0022). */
export type LpStamp = { server: number | null; client: number; mono: number; origin: number };

/** The journey of one sampled live-price batch: created at arrival, stamped once per stage. */
export type LpTrace = {
  /** Client trace id (32 hex), one per batch per client. */
  id: string;
  backendTraceId: string;
  marketTs: number;
  rowCount: number;
  /** Worker grid version the batch's last update landed in; set at `calculated`. */
  version?: number;
  ts: Partial<Record<LpStage, LpStamp>>;
};

export const stampNow = (): LpStamp => ({
  server: serverClock.now(),
  client: Date.now(),
  mono: performance.now(),
  origin: performance.timeOrigin,
});

export const newTraceId = (): string => crypto.randomUUID().replace(/-/g, "");
